"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

var _apiKeys = _interopRequireDefault(require("./api-keys"));

var _collaborators = _interopRequireDefault(require("./collaborators"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Organizations = /*#__PURE__*/function () {
  function Organizations(api) {
    (0, _classCallCheck2["default"])(this, Organizations);
    this._api = api;
    this.ApiKeys = new _apiKeys["default"](api.OrganizationAccess, {
      parentRoutes: {
        get: 'organization_ids.organization_id',
        list: 'organization_ids.organization_id',
        create: 'organization_ids.organization_id',
        update: 'organization_ids.organization_id'
      }
    });
    this.Collaborators = new _collaborators["default"](api.OrganizationAccess, {
      parentRoutes: {
        get: 'organization_ids.organization_id',
        list: 'organization_ids.organization_id',
        set: 'organization_ids.organization_id'
      }
    });
    (0, _autoBind["default"])(this);
  } // Retrieval.


  (0, _createClass2["default"])(Organizations, [{
    key: "getAll",
    value: function () {
      var _getAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(params, selector) {
        var response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.OrganizationRegistry.List(undefined, _objectSpread(_objectSpread({}, params), _marshaler["default"].selectorToFieldMask(selector)));

              case 2:
                response = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadListResponse('organizations', response));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAll(_x, _x2) {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "getById",
    value: function () {
      var _getById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(id, selector) {
        var fieldMask, response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context2.next = 3;
                return this._api.OrganizationRegistry.Get({
                  routeParams: {
                    'organization_ids.organization_id': id
                  }
                }, fieldMask);

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getById(_x3, _x4) {
        return _getById.apply(this, arguments);
      }

      return getById;
    }()
  }, {
    key: "search",
    value: function () {
      var _search = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(params, selector) {
        var response;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._api.EntityRegistrySearch.SearchOrganizations(undefined, _objectSpread(_objectSpread({}, params), _marshaler["default"].selectorToFieldMask(selector)));

              case 2:
                response = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].payloadListResponse('organizations', response));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function search(_x5, _x6) {
        return _search.apply(this, arguments);
      }

      return search;
    }() // Creation.

  }, {
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(userId, organization) {
        var response;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._api.OrganizationRegistry.Create({
                  routeParams: {
                    'collaborator.user_ids.user_id': userId
                  }
                }, {
                  organization: organization
                });

              case 2:
                response = _context4.sent;
                return _context4.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function create(_x7, _x8) {
        return _create.apply(this, arguments);
      }

      return create;
    }() // Update.

  }, {
    key: "updateById",
    value: function () {
      var _updateById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(id, patch) {
        var mask,
            response,
            _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                mask = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : _marshaler["default"].fieldMaskFromPatch(patch);
                _context5.next = 3;
                return this._api.OrganizationRegistry.Update({
                  routeParams: {
                    'organization.ids.organization_id': id
                  }
                }, {
                  organization: patch,
                  field_mask: _marshaler["default"].fieldMask(mask)
                });

              case 3:
                response = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function updateById(_x9, _x10) {
        return _updateById.apply(this, arguments);
      }

      return updateById;
    }()
  }, {
    key: "restoreById",
    value: function () {
      var _restoreById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(id) {
        var response;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._api.OrganizationRegistry.Restore({
                  routeParams: {
                    organization_id: id
                  }
                });

              case 2:
                response = _context6.sent;
                return _context6.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function restoreById(_x11) {
        return _restoreById.apply(this, arguments);
      }

      return restoreById;
    }() // Deletion.

  }, {
    key: "deleteById",
    value: function () {
      var _deleteById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(organizationId) {
        var response;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._api.OrganizationRegistry.Delete({
                  routeParams: {
                    organization_id: organizationId
                  }
                });

              case 2:
                response = _context7.sent;
                return _context7.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function deleteById(_x12) {
        return _deleteById.apply(this, arguments);
      }

      return deleteById;
    }()
  }, {
    key: "purgeById",
    value: function () {
      var _purgeById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(organizationId) {
        var response;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._api.OrganizationRegistry.Purge({
                  routeParams: {
                    organization_id: organizationId
                  }
                });

              case 2:
                response = _context8.sent;
                return _context8.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function purgeById(_x13) {
        return _purgeById.apply(this, arguments);
      }

      return purgeById;
    }() // Miscellaneous.

  }, {
    key: "getRightsById",
    value: function () {
      var _getRightsById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(organizationId) {
        var result;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this._api.OrganizationAccess.ListRights({
                  routeParams: {
                    organization_id: organizationId
                  }
                });

              case 2:
                result = _context9.sent;
                return _context9.abrupt("return", _marshaler["default"].unwrapRights(result));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getRightsById(_x14) {
        return _getRightsById.apply(this, arguments);
      }

      return getRightsById;
    }() // Events stream.

  }, {
    key: "openStream",
    value: function () {
      var _openStream = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(identifiers, names, tail, after) {
        var payload;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                payload = {
                  identifiers: identifiers.map(function (id) {
                    return {
                      organization_ids: {
                        organization_id: id
                      }
                    };
                  }),
                  names: names,
                  tail: tail,
                  after: after
                };
                return _context10.abrupt("return", this._api.Events.Stream(undefined, payload));

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function openStream(_x15, _x16, _x17, _x18) {
        return _openStream.apply(this, arguments);
      }

      return openStream;
    }()
  }]);
  return Organizations;
}();

var _default = Organizations;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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